import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { NormalInputBase } from '../NormalInputBase';
const WHOLE_NUMBER_INPUT_REGEX = /[^0-9]/g;
const WHOLE_NUMBER_INPUT_PATTERN = '[0-9]*';
export const NumberInput = forwardRef(({ onlyWholeNumbers, ...props }, ref) => {
    if (!onlyWholeNumbers) {
        return _jsx(NormalInputBase, { ref: ref, type: 'number', ...props });
    }
    const handleInput = (e) => {
        e.currentTarget.value = e.currentTarget.value.replace(WHOLE_NUMBER_INPUT_REGEX, '');
    };
    return (_jsx(NormalInputBase, { ref: ref, type: 'text', pattern: WHOLE_NUMBER_INPUT_PATTERN, onInput: handleInput, ...props }));
});
